import styles from 'views/widgets/Input/InputText.css';
import classnames from 'classnames';
import React, { Component, PropTypes } from 'react';

export default class InputText extends Component {
  static propTypes = {
    value: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    error: PropTypes.bool,
    className: PropTypes.string,
    loading: PropTypes.bool
  };

  render () {
    let {value, disabled, onChange, placeholder, error, className, loading, ...props} = this.props;
    return (
      <div className={styles.wrapper}>
        <input
          ref='input'
          type='text'
          disabled={disabled || false}
          className={classnames(styles.input_text, {[styles.input_disabled]: disabled,
            [styles._error]: error}, className)}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          {...props}/>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/widgets/Input/InputText.js
 **/